import { useState } from 'react'
import { PillTabs } from '../../components/ui'
import { AdminCosts } from './AdminCosts'
import { AdminAiUsage } from './AdminAiUsage'
import { AdminMonetization } from './AdminMonetization'
import { AdminPayouts } from './AdminPayouts'
import { AdminPayoutHistory } from './AdminPayoutHistory'
import { AdminRagEarnings } from './AdminRagEarnings'

const SUB_TABS = [
  { key: 'costs',         label: 'AI Costs' },
  { key: 'usage',         label: 'AI Usage' },
  { key: 'monetization',  label: 'Monetization' },
  { key: 'payouts',       label: 'Webhook Payouts' },
  { key: 'payoutHistory', label: 'Payout History' },
  { key: 'ragEarnings',   label: 'RAG Payouts' },
] as const

type SubTab = typeof SUB_TABS[number]['key']

export function AdminAnalyticsHub() {
  const [sub, setSub] = useState<SubTab>('costs')

  return (
    <div>
      <PillTabs tabs={[...SUB_TABS]} active={sub} onChange={setSub} style={{ marginBottom: '1.25rem' }} />
      {sub === 'costs'         && <AdminCosts />}
      {sub === 'usage'         && <AdminAiUsage />}
      {sub === 'monetization'  && <AdminMonetization />}
      {sub === 'payouts'       && <AdminPayouts />}
      {sub === 'payoutHistory' && <AdminPayoutHistory />}
      {sub === 'ragEarnings'   && <AdminRagEarnings />}
    </div>
  )
}
